import moment from "moment";
import React from "react";

// Assets
import "~/assets/sass/pages/invest/IrModal/outcome.scss";
import { thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";

const OutcomeView = ({ irOutcome }) => {
	const { t } = useTranslation();

	return (
		<>
			{/*성과및계획 view*/}
			<div className="outcome-view">
				<div className="data-form">
					<section>
						<h3 className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.outcome.section1.title"
							)}
						</h3>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<div className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.outcome.section1.label01"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								{irOutcome?.IROutcomeInvest?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="content">{d.name}</li>
										<li className="value">{thousandFormatter(d.value)}</li>
										<li className="date">
											{moment(d.date).format("YYYY-MM-DD")}
										</li>
									</ul>
								))}
							</div>
							<div className="f__group">
								<div className="f__label">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.outcome.section1.label02"
									)}
								</div>
								{irOutcome?.IROutcomeAward?.map((d) => (
									<ul className="f__control award" key={d.idx}>
										<li className="content">{d.name}</li>
										<li className="value">{d.content}</li>
										<li className="date">
											{moment(d.date).format("YYYY-MM-DD")}
										</li>
									</ul>
								))}
							</div>
						</div>
						<div className="c__form vertical sub-section">
							<div className="f__group">
								<div className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.outcome.section1.label03"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								{irOutcome?.IROutcomeExport?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="content">{d.name}</li>
										<li className="value">{thousandFormatter(d.value)}</li>
										<li className="date">
											{moment(d.date).format("YYYY-MM-DD")}
										</li>
									</ul>
								))}
							</div>
							<div className="f__group">
								<div className="f__label unit-wrap">
									{t(
										"pages.investment.InvestEvalPage.detail.modal.outcome.section1.label04"
									)}
									<span className="unit">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.basicInfo.section3.label03-1"
										)}
									</span>
								</div>
								{irOutcome?.IROutcomeFund?.map((d) => (
									<ul className="f__control" key={d.idx}>
										<li className="content">{d.name}</li>
										<li className="value">{thousandFormatter(d.value)}</li>
										<li className="date">
											{moment(d.date).format("YYYY-MM-DD")}
										</li>
									</ul>
								))}
							</div>
						</div>
					</section>
					<section className="outcome-plan">
						<h3 className="section-title">
							{t(
								"pages.investment.InvestEvalPage.detail.modal.outcome.section2.title"
							)}
						</h3>
						<div className="outcome-plan-table">
							<div className="thead">
								<div className="tr">
									<div className="th">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.outcome.section2.tableHead01"
										)}
									</div>
									<div className="th">
										{t(
											"pages.investment.InvestEvalPage.detail.modal.outcome.section2.tableHead02"
										)}
									</div>
									<div className="th">+3M</div>
									<div className="th">+6M</div>
									<div className="th">+12M</div>
								</div>
							</div>
							<div className="tbody">
								{irOutcome?.IROutcomePlan?.map((d) => (
									<div className="tr" key={d.idx}>
										<div className="td plan-indicator">{d.indicator}</div>
										<div className="td">{d.now}</div>
										<div className="td">{d.three}</div>
										<div className="td">{d.six}</div>
										<div className="td">{d.twelve}</div>
									</div>
								))}
							</div>
						</div>
					</section>
				</div>
			</div>
		</>
	);
};

export default OutcomeView;
